import { TableRow, Theme } from "@mui/material";
import TableCell from "@mui/material/TableCell";
import { createTheme, getContrastRatio, styled } from "@mui/material/styles";

import { PROPOSITION, Proposition } from "./services/api/Resolver";

declare module "@mui/material/styles" {
  interface PaletteOptions {
    dark: any;
  }
}

declare module "@mui/material/Chip" {
  interface ChipPropsColorOverrides {
    dark: true;
  }
}

const dark = {
  main: "#343a40",
  light: "#ffffff",
  dark: "#b8b8b8",
  contrastText: getContrastRatio("#343a40", "#fff") > 4.5 ? "#fff" : "#111",
};

const themeComponents = {
  MuiCssBaseline: {
    styleOverrides: (theme: Theme) => ({
      a: {
        color: theme.palette.primary.main,
      },
    }),
  },
};

export function getTheme(proposition: Proposition, mode: "light" | "dark"): Theme {
  switch (proposition) {
    case "Peacock":
      return createTheme({
        palette: {
          dark: dark,
          mode: mode,
        },
        components: themeComponents,
      });
    case "SkyShowtime":
      return createTheme({
        palette: {
          dark: dark,
          mode: mode,
          primary: {
            main: "#795fe3",
          },
        },
        components: themeComponents,
      });
    case "NowTV":
      return createTheme({
        palette: {
          dark: dark,
          mode: mode,
          primary: {
            main: "#00818a",
          },
        },
        components: themeComponents,
      });
  }
}

function getLogoPath(proposition: Proposition): string {
  switch (proposition) {
    case "Peacock":
      return "/logo/peacock.svg";
    case "SkyShowtime":
      return "/logo/skyshowtime.svg";
    case "NowTV":
      return "/logo/skynow.svg";
  }
}

export const logoURL = process.env.PUBLIC_URL + getLogoPath(PROPOSITION);

export const StripedTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

export const DefaultHeaderCell = styled(TableCell)(() => ({
  textAlign: "center",
  fontWeight: "bold",
}));

export const DefaultContentCell = styled(TableCell)(() => ({
  textAlign: "left",
  wordBreak: "break-all",
}));

export const CentredContentCell = styled(TableCell)(() => ({
  textAlign: "center",
  wordBreak: "break-all",
}));
